<template>
  <v-card class="overflow-x-auto" color="rgba(255, 255, 255, .25" outlined>
    <v-rating v-if="type === 'star'" v-model="valueComputed" :value="value" background-color="grey"
              class="d-flex justify-center" half-increments hover
              length="5" size="32"/>

    <v-btn-toggle v-else v-else-if="toggleIncludes.includes(type)" v-model="valueComputed" class="w-100"
                  group>
      <v-btn v-for="(item, i) in items[type]" :key="i" :color="item.color ? item.color : 'primary'" class="flex" text>
        <h1 v-if="type === 'emoji'" class="ma-0">{{ item }}</h1>
        <v-icon v-else-if="type === 'thumbs' && item.text.startsWith('mdi')" v-text="item.text"/>
        <span v-else>{{ item }}</span>
      </v-btn>
    </v-btn-toggle>

    <div v-else-if="type === 'emoji_slider'" class="px-4 pt-6 pb-2 overflow-hidden">
      <v-slider v-model="valueComputed" :thumb-size="0" hide-details step="25" thumb-label="always">
        <template v-slot:thumb-label="{ value }">
          <h1>{{ satisfactionEmojis[Math.min(Math.floor(value / 20), 4)] }}</h1>
        </template>
      </v-slider>
    </div>

    <div v-else-if="type === 'slider'" class="px-4 pt-6 pb-2 overflow-hidden">
      <v-slider v-model="valueComputed" :thumb-size="20" hide-details thumb-label="always"/>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "feedbackType",

  props: {
    value: [Number, String],
    type: String
  },

  data: () => ({
    items: {
      thumbs: [{
        text: 'mdi-thumb-down-outline',
        color: 'third'
      }, {
        text: 'mdi-thumb-up-outline',
        color: 'success'
      }],
      text: ['خیلی ضعیف', 'ضعیف', 'متوسط', 'خوب', 'عالی'],
      emoji: ['😢', '🙁', '😐', '😊', '😍']
    },
    satisfactionEmojis: ['😢', '🙁', '😐', '😊', '😍'],
    toggleIncludes: ['thumbs', 'text', 'emoji'],
  }),

  computed: {
    valueComputed: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    type(val) {
      this.valueComputed = null
    }
  }
}
</script>

<style scoped>
.v-btn-toggle >>> .v-btn {
  filter: grayscale(1);
}

.v-btn-toggle >>> .v-btn--active {
  filter: none !important;
}
</style>